import React = require('react');
import { flow, get } from 'lodash';
import { Field, formValueSelector, getFormSyncErrors, InjectedFormProps, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { IStore } from '../../../../../redux/IStore';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import FieldFormControl from '../../../../../components/FieldFormControl';
import { hasEmojis, isRequired } from '../../../../../util/validators';
import { CustomInputError } from '../../../../../components/CustomInputError';
import { ITraveller } from '../../../../../data/api/models';
import { useEffect, useState } from 'react';
import { validateQuoteRetrieval } from '../../../../../data/api/api';

interface IValidateRetrieveQuoteModalProps extends InjectedFormProps {
  showModal: boolean;
  closeModal: any;
  synchronousError: any;
  leadTraveller: ITraveller;
  dob: any;
  postcode: string;
  declineQuote: any;
  quoteId: string;
}

const ValidateRetrieveQuoteModal = ({
                                      showModal,
                                      handleSubmit,
                                      closeModal,
                                      valid,
                                      synchronousError,
                                      leadTraveller,
                                      dob,
                                      postcode,
                                      quoteId,
                                      declineQuote,
                                    }: IValidateRetrieveQuoteModalProps) => {

  const [maxTries, setMaxTries] = useState(1);
  const [credentialsError, setCredentialsError] = useState(false);

  useEffect(() => {
    setCredentialsError(false);
  }, [dob, postcode]);

  const onConfirm = () => () => {
    Promise.resolve(validateQuoteRetrieval({ dob, postcode, quoteId })).then((res) => {
      if (res) {
        closeModal();
      }
    }).catch((error) => {
      setMaxTries(maxTries + 1);
      setCredentialsError(true);
      if (maxTries === 5) {
        declineQuote()
      }
    })
  }

  const dobError = get(synchronousError, 'dob')

  return (
    <Form horizontal={true} onSubmit={handleSubmit} autoComplete="off">
      <Modal show={showModal} onHide={closeModal} keyboard={false} backdrop={'static'}>
        <Modal.Header closeButton={false}>
          <Modal.Title>Confirm Identity</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Row className={'adm-form-group'}>
            <Col xs={6} className={'full-width-xs'}>Your date of birth</Col>
            <Col xs={2} className={'full-width-xs'}>
              <Field
                name={`dob.day`}
                inputmode="numeric"
                type="text"
                maxLength={'2'}
                placeholder={'DD'}
                component={FieldFormControl}
                validate={[isRequired, hasEmojis]}
                validationMessage={'single'}
                autocomplete="new-password"
              />
              Day
            </Col>
            <Col xs={2} className={'full-width-xs'}>
              <Field
                name={`dob.month`}
                inputmode="numeric"
                type="text"
                maxLength={'2'}
                placeholder={'MM'}
                component={FieldFormControl}
                validate={[isRequired, hasEmojis]}
                validationMessage={'single'}
                autocomplete="new-password"
              />
              Month
            </Col>
            <Col xs={2} className={'full-width-xs'}>
              <Field
                name={`dob.year`}
                inputmode="numeric"
                type="text"
                maxLength={'4'}
                placeholder={'YYYY'}
                component={FieldFormControl}
                validate={[isRequired, hasEmojis]}
                validationMessage={'single'}
                autocomplete="new-password"
              />
              Year
            </Col>
            <Col xs={6}/>
            <Col xs={6}>
              {dobError && (
                <div style={{ textAlign: 'left' }}>
                  <Col>
                    <div className={dobError ? 'has-error' : ''}>
                      {<CustomInputError errorMessage={'Date of birth Required'}/>}
                    </div>
                  </Col>
                </div>
              )}
            </Col>
            <Col xs={6} className={'full-width-xs'}>Your home postcode</Col>
            <Col xs={6} className={'full-width-xs'}>
              <Field
                name={`postcode`}
                type="text"
                component={FieldFormControl}
                validate={[isRequired]}
                autocomplete="new-password"
              />
            </Col>
            <Col xs={12}>
              {credentialsError && (
                <div style={{ textAlign: 'left' }}>
                  <Col>
                    <div className={credentialsError ? 'has-error' : ''}>
                      {<CustomInputError
                        errorMessage={`You credentials dont match. Pls retry. Remaining tries ${6 - maxTries}`}/>}
                    </div>
                  </Col>
                </div>
              )}
            </Col>
          </Row>


          <div style={{ marginTop: '20px' }}>
            <Button
              bsSize={'small'}
              type="button"
              block={true}
              disabled={!valid || maxTries === 6}
              onClick={onConfirm()}
              className={'admiral-primary-btn'}>
              CONFIRM AND CONTINUE
            </Button>
          </div>

        </Modal.Body>
      </Modal>
    </Form>
  )
}

let selector;

const validate = (values) => {
  const errors = {
    dob: ''
  };
  if (!get(values, 'dob.day') || !get(values, 'dob.month') || !get(values, 'dob.year')) {
    errors.dob = 'Date of birth required';
  }
  return errors;
};


export default flow([
  reduxForm({
    form: 'retrieve_quote',
    validate,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('retrieve_quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const dob = selector(state, 'dob');
      const postcode = selector(state, 'postcode');
      const synchronousError = getFormSyncErrors('retrieve_quote')(state);

      return {
        dob,
        postcode,
        synchronousError,
        initialValues: {
          dob: {
            day: '',
            month: '',
            year: ''
          },
          postcode: ''
        }
      };
    },
  ),
])(ValidateRetrieveQuoteModal);
